<template>
  <div>
    <el-form ref="searchForm" :model="searchForm" inline>
      <el-form-item label="产品型号:" prop="projectCode">
        <el-input v-model.trim="searchForm.productName" placeholder="请输入产品型号" style="width: 300px;" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch">
          搜索
        </el-button>
        <el-button type="default" @click="clearSearchForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div class="upload-template-style">
      <div class="upload-wrap">
        <el-upload
          action=""
          multiple
          :show-file-list="false"
          :http-request="uploadTaxInvoice"
        >
          <el-button v-if="perssimionCodeList&&isViewBatteryManagementButton" :loading="isUploadLoading" type="primary">
            导入
          </el-button>
        </el-upload>
      </div>
      <div v-if="perssimionCodeList&&isViewBatteryManagementButton" class="download-template-style">
        <el-button type="text" size="medium" @click="downloadTemplate">
          导入模板下载
        </el-button>
      </div>
    </div>
    <div>
      <el-table v-loading="tableLoading" :data="tableData" border>
        <!-- 产品型号 -->
        <el-table-column prop="productName" label="产品型号" align="left">
          <template v-slot="{row}">
            <template v-if="row.isInputEdit">
              <el-input
                v-model="row.productName"
                placeholder="请输入要修改的产品型号"
                @change="onBlurEdit(row,1)"
              />
            </template>
            <template v-else>
              {{ row.productName }}
            </template>
          </template>
        </el-table-column>
        <!-- 运输方式 -->
        <el-table-column
          label="运输方式"
          prop="transportMode"
          align="left"
        >
          <template v-slot="{row}">
            <template v-if="row.isSelectEdit">
              <el-select
                v-model="row.transportMode"
                placeholder="请选择货运属性"
                class="select-transport-mode"
                @change="onBlurEdit(row,2)"
              >
                <el-option
                  v-for="(item) in transportModeOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
            <template v-else>
              {{ row.transportMode }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button v-if="perssimionCodeList&&isViewBatteryManagementButton" type="text" @click="editAddress(row,'edit')">
              编辑
            </el-button>
            <el-popover v-model="row.removeVisible" width="160" class="popover-style">
              <p class="popover-tips-style">
                确认删除该条数据吗?
              </p>
              <div class="popover-tips-container-style">
                <el-button size="mini" type="text" @click="row.removeVisible = false">
                  取消
                </el-button>
                <el-button type="primary" size="mini" @click="deleteAddress(row)">
                  确定
                </el-button>
              </div>
              <el-button v-if="perssimionCodeList&&isViewBatteryManagementButton" slot="reference" type="text" style="color: #409EFF;">
                删除
              </el-button>
            </el-popover>
            <!-- 电池认证路由 && 没有按钮权限 -->
            <span v-if="perssimionCodeList&&!isViewBatteryManagementButton">
              ——
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="pageState.pageSize"
        :current-page.sync="pageState.pageIndex"
        layout="->,total, prev, pager, next, jumper,sizes"
        :total="pageState.total"
        style="margin-top: 10px"
        @size-change="handlerSizeChange"
        @current-change="handlerCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getImportBatterData,
  getBatteryDataList,
  deleteBatteryImportRowDataList,
  updateBatteryImportRowDataList
} from '@/API/international.js';
import { mapState } from 'vuex';
import { downloadUrlFile } from '@/libs/util';
/**
 * 电池认证管理
 */
export default {
  name: 'InternationalInvoiceHasBeenApplied',
  data () {
    return {
      searchForm: {
        productName: ''
      },

      isEditType: false, // 是否显示编辑
      pageState: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      isUploadLoading: false,
      tableLoading: false,
      tableData: [],
      transportModeOption: [{
        value: '海运',
        label: '海运',
        transportMode: ''
      }, {
        value: '空运',
        label: '空运',
        transportMode: ''
      }]
    };
  },
  methods: {
    // 搜索事件
    handleSearch () {
      this.getImportDataListMethods();
    },
    // 重置搜索
    clearSearchForm () {
      this.searchForm.productName = '';
      this.pageState.pageIndex = 1;
      this.pageState.pageSize = 10;
      this.getImportDataListMethods();
    },
    // 校验导入金税发票
    uploadTaxInvoice (upload) {
      this.isUploadLoading = true;
      let formDate = new FormData();
      formDate.append('file', upload.file);
      getImportBatterData(formDate).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.$message.success(data);
          this.getImportDataListMethods();
          this.isUploadLoading = false;
        } else {
          this.isUploadLoading = false;
        }
      })
        .catch(() => {
          this.isUploadLoading = false;
        });
    },
    // 获取导入后的列表数据
    getImportDataListMethods () {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageState.pageSize,
        pageNum: this.pageState.pageIndex,
        productName: this.searchForm.productName
      };
      getBatteryDataList(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.pageState.total = data.total || 0;
          const newData = data.list.map(item => {
            return {
              ...item,
              isSelectEdit: false,
              isInputEdit: false,
              removeVisible: false
            };
          });
          this.tableData = newData;
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    downloadTemplate () {
      downloadUrlFile('/电池认证模板.xlsx');
    },
    // 编辑
    editAddress (row) {
      row.isInputEdit = true;
      row.isSelectEdit = true;
    },
    // 运输方式失去焦点自动保存
    onBlurEdit (row, editType) {
      // input失焦以后保存
      if (editType === 1) {
        row.isInputEdit = false;
        this.updateBatteryImportRowDataListMethods(row);
      }
      // select失焦点以后保存
      if (editType === 2) {
        row.isSelectEdit = false;
        this.updateBatteryImportRowDataListMethods(row);
      }
    },
    // 编辑接口
    updateBatteryImportRowDataListMethods (row) {
      if (!row) return;
      this.tableLoading = true;
      let params = {
        id: row.id,
        productName: row.productName,
        transportMode: row.transportMode,
        createdBy: row.createdBy,
        createdTime: row.createdTime,
        updatedBy: row.updatedBy,
        updatedTime: row.updatedTime
      };
      updateBatteryImportRowDataList(params).then(res => {
        let { status } = res.data;
        if (status === '200') {
          this.$message.success('编辑成功!');
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    // 删除
    deleteAddress (row) {
      this.tableLoading = true;
      deleteBatteryImportRowDataList(row.id).then(res => {
        let { status } = res.data;
        if (status === '200') {
          this.$message.success('删除成功!');
          row.removeVisible = false;
          this.tableLoading = false;
          this.getImportDataListMethods();
        } else {
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    handlerSizeChange (size) {
      this.pageState.pageSize = size;
      this.getImportDataListMethods();
    },
    handlerCurrentChange (index) {
      this.pageState.pageIndex = index;
      this.getImportDataListMethods();
    }

  },
  computed: {
    ...mapState({
      // 根据当前登录用户返回的,菜单集合,判断是否是电池管理认证路由
      perssimionCodeList: state => state.user.perssimionCodeList.some(i => i === 'batteryCertificationManagement'),
      // 根据当前登录用户返回的,按钮权限集合,控制按钮的显示隐藏
      isViewBatteryManagementButton: state => state.user.perssimionBatteryManagement.some(i => i.buttonFlag === true)
    })
  },
  mounted () {
    this.getImportDataListMethods();
  }
};
</script>

<style scoped lang="scss">
.upload-template-style{
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.download-template-style{
  margin-left: 20px;
}
.select-transport-mode{
  width: 100%;
}
.popover-style{
  display: inline-block;
  margin: 0 10px
}
.popover-tips-style{
  line-height: 30px;
}
.popover-tips-container-style{
  text-align: right;
  margin: 0
}
</style>
